import styled from "styled-components";
import { HeaderSectionContainer } from "App/styles";
import { breakpoints } from "definitions";

// El filtro va en dos líneas: arriba la búsqueda por texto, que ocupa el ancho
// de los tres selects, y abajo los selects. Los botones van en una cuarta
// columna que abarca las dos filas, uno arriba del otro. Es una grilla para que
// el borde derecho del buscador caiga justo sobre el del último select.
export const EntriesFilter = styled(HeaderSectionContainer)`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr)) auto;
  column-gap: 2rem;
  row-gap: 1.5rem;
  align-items: end;
  height: auto;

  .search-field {
    grid-column: 1 / 4;
  }

  ${breakpoints.laptop} {
    grid-template-columns: repeat(3, minmax(0, 1fr));

    .search-field {
      grid-column: 1 / -1;
    }
  }

  ${breakpoints.phablet} {
    grid-template-columns: minmax(0, 1fr);
  }
`;

// Los botones se ubican explícitamente en la cuarta columna, sobre las dos
// filas: al ocupar ese lugar antes del auto-placement, los selects bajan a la
// segunda fila en vez de meterse en el hueco que deja el buscador. Con
// `subgrid` heredan las filas de la grilla, así que cada botón queda al pie de
// la suya, a la altura del campo que tiene al lado.
export const FilterActions = styled.div`
  grid-column: 4;
  grid-row: 1 / 3;
  display: grid;
  grid-template-rows: subgrid;
  align-items: end;

  button {
    width: 100%;
    margin: 0;
  }

  ${breakpoints.laptop} {
    grid-column: 1 / -1;
    grid-row: auto;
    display: flex;
    gap: 1.5rem;
  }
`;

// El paginador copia el ancho del listado (`ListOfEntries/styles` → Container)
// para que sus bordes caigan justo sobre los de las filas, y el mismo redondeo
// y sombra que las filas para que se lea como el pie de la misma tarjeta.
export const PaginationFooter = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 124.5rem;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.15);

  ${breakpoints.tablet} {
    width: 80%;
  }

  ${breakpoints.mobile} {
    width: 95%;
  }
`;
